var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCameraDome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.315 6.64512C2.02682 5.53401 2.76586 4.25 4.03854 4.25H19.9623C21.235 4.25 21.974 5.53401 21.6859 6.64512L21.6758 6.68399L20.7504 9.13677V11.381C20.7504 16.0371 16.798 19.75 12.0004 19.75C7.20285 19.75 3.25043 16.0371 3.25043 11.381V9.13677L2.32509 6.68399L2.315 6.64512ZM4.75043 9.75V11.381C4.75043 15.1406 7.96147 18.25 12.0004 18.25C16.0394 18.25 19.2504 15.1406 19.2504 11.381V9.75H4.75043ZM19.4818 8.25L20.2409 6.2379C20.268 6.09955 20.2347 5.97026 20.1718 5.87837C20.1053 5.78127 20.027 5.75 19.9623 5.75H4.03854C3.97385 5.75 3.89559 5.78127 3.8291 5.87837C3.76618 5.97026 3.73285 6.09955 3.75999 6.2379L4.51908 8.25H19.4818ZM12.0004 12.75C11.3146 12.75 10.7504 13.3142 10.7504 14C10.7504 14.6858 11.3146 15.25 12.0004 15.25C12.6862 15.25 13.2504 14.6858 13.2504 14C13.2504 13.3142 12.6862 12.75 12.0004 12.75ZM9.25043 14C9.25043 12.4858 10.4862 11.25 12.0004 11.25C13.5146 11.25 14.7504 12.4858 14.7504 14C14.7504 15.5142 13.5146 16.75 12.0004 16.75C10.4862 16.75 9.25043 15.5142 9.25043 14Z",
    fill: "#747E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraDome);
export default __webpack_public_path__ + "static/media/icon-camera-dome.2a2847279927d51802fbc75e3460f227.svg";
export { ForwardRef as ReactComponent };